import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class CustomerPaymentMethodID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
